<div
	class="store-card flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between p-3 border-round shadow-2 w-full"
>
	<div class="flex-1 min-w-0 mb-3 md:mb-0">
		<div class="flex align-items-center mb-1">
			<span class="font-bold text-base mr-2 store-name">{{ store.nombre }}</span>
			<div
				class="flex align-items-center distance-badge px-2 py-1 border-round"
				*ngIf="store.distancia != null"
			>
				<app-icon iconName="route" class="text-xs mr-1"></app-icon>
				<span class="text-xs font-normal">
					{{ store.distancia | number: '1.2-2' }} {{ translations['storeDistance'] }}
				</span>
			</div>
		</div>
		<p class="m-0 text-sm mb-2 store-address">{{ store.ubicacion?.direccion }}</p>
		<div class="flex align-items-center">
			<div class="circle" [class.open]="isAvailable"></div>
			<p class="m-0 text-xs store-schedule-text">
				{{ scheduleText }}
			</p>
		</div>
	</div>
	<div class="flex-shrink-0 w-full md:w-auto" *ngIf="isAvailable">
		<app-button
			type="button-primary"
			class="w-full md:w-auto"
			[text]="translations['select']"
			(buttonClicked)="onSelect()"
		></app-button>
	</div>
</div>
